import { render, staticRenderFns } from "./DrugAutoUpdateSelector.vue?vue&type=template&id=556ceffd&"
import script from "./DrugAutoUpdateSelector.vue?vue&type=script&lang=js&"
export * from "./DrugAutoUpdateSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports